import { useMemo } from 'react'
import { Grid } from '@sport1/react-elements'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import React, { memo } from 'react'
import Touchable from '@sport1/react-elements/Touchable'
import { useTheme } from '@sport1/react-elements'
import { spacings } from '../../DesignSystem/spacings'
import Image from '../../Image'
import { useGetSquareTeaserStyles } from './useGetSquareTeaserStyles'
import { SquareTeaserProps } from './types'
import Font from '@/Fonts/Font'

const SquareTeaser = ({
    mainImageUrl,
    teaserHeadline,
    teaserInfo,
    teaserInfoIconName,
    onPress,
    href,
    size = 'M',
    webTarget = '_self',
    innerRef,
    testID,
}: SquareTeaserProps) => {
    const {
        height,
        width,
        teaserInfoIconSize,
        iconMarginRight,
        headlineFontVariant,
        infoFontVariant,
    } = useGetSquareTeaserStyles(size)

    const { surfaceColors } = useTheme()

    const shouldExpand = useMemo(() => !teaserHeadline && !teaserInfo, [teaserHeadline, teaserInfo])

    return (
        <Grid
            horizontal
            position="relative"
            noExpand={shouldExpand}
            width={width}
            ref={innerRef}
            testID="square-teaser"
        >
            <Touchable
                href={href}
                webTarget={webTarget}
                height="100%"
                width="100%"
                onPress={onPress}
                testID={`${testID}-touchable`}
            >
                <Image height={height} width={width} src={mainImageUrl || ''} />
                {(teaserHeadline || teaserInfo) && (
                    <Grid
                        padding={spacings['spacing-6']}
                        backgroundColor={surfaceColors['background-secondary']}
                    >
                        {teaserHeadline && (
                            <Font
                                fontVariant={headlineFontVariant}
                                fontFamilyVariant="Sport1-Bold-Headline"
                                numberOfLines={3}
                                testID="teaser-headline"
                            >
                                {teaserHeadline}
                            </Font>
                        )}
                        {teaserInfo && (
                            <Grid
                                horizontal
                                alignBottom
                                marginTop={spacings['spacing-3']}
                                testID="teaser-info"
                            >
                                <Grid horizontal centerVertical>
                                    {teaserInfoIconName && (
                                        <FontelloIcon
                                            name={teaserInfoIconName}
                                            fontSize={teaserInfoIconSize}
                                            marginRight={iconMarginRight}
                                            color={surfaceColors['background-invert']}
                                        />
                                    )}
                                    <Font
                                        fontVariant={infoFontVariant}
                                        fontFamilyVariant="Sport1-Regular"
                                    >
                                        {teaserInfo}
                                    </Font>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                )}
            </Touchable>
        </Grid>
    )
}

export default memo(SquareTeaser)
